import React, { Component } from "react";
import axios from "axios";
import { LangContext } from "../LangContext.jsx";

class ApiPersonPanel extends Component {
  static contextType = LangContext;

  constructor(props) {
    super(props);
    this.state = {
      custom: false,
      errorName: false,
      name: '',
      permissions: [],
    };
  }

  componentDidMount() {
    $("#kt_daterangepicker_1").datepicker();
    this.getPermissions();
  }

  getPermissions = async () => {
    const URL = `/api/permissions`;
    await axios.get(URL).then((res) => {
      this.setState({ permissions: res.data });
    });
  };

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  };

  handleExpirationChange = (e) => {
    if (e.target.value == 'custom') {
      this.setState({ custom: true }, () => {
        $("#kt_daterangepicker_1").datepicker();
      });
    } else {
      this.setState({ custom: false });
    }
  };

  onSubmit = (e) => {
    const { name } = this.state;
    if (name == '') {
      this.setState({ errorName: true });
      e.preventDefault();
    }
    return true;
  };

  render() {
    const { lang } = this.context;
    const { custom, errorName, name } = this.state;
    const { token } = this.props;

    return (
      <div className="d-flex flex-column-fluid">
        <div className="container">
          <div className="card card-custom gutter-b">
            <div className="card-body">
              <form id="frmProvider" action="/people/api/create_token" method="post" onSubmit={this.onSubmit}>
                <input type="hidden" name="_token" value={token} />
                <div className="row text-left">
                  <div className="col-sm-4 align-self-center form-group">
                    <label className="text-left">{lang.get('messages.nombre')}</label>
                    <input
                      id="name"
                      type="text"
                      placeholder={lang.get('messages.describe_para_que_sera_utilizado_este_token')}
                      className="form-control form-control-solid"
                      name="name"
                      autoFocus
                      value={name}
                      onChange={this.handleNameChange}
                    />
                    {errorName ? (
                      <div className="fv-plugins-message-container">
                        <div data-field="name" data-validator="notEmpty" className="fv-help-block">
                          Nombre requerido
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="row text-left">
                  <div className="col-sm-4 align-self-center form-group">
                    <label className="text-left">{lang.get('messages.fecha_de_expiracion')}</label>
                    <select name="expired_at" className="form-control form-control-solid" onChange={this.handleExpirationChange}>
                      <option value="30">30 {lang.get('messages.dia')}s</option>
                      <option value="60">60 {lang.get('messages.dias')}</option>
                      <option value="90">90 {lang.get('messages.dias')}</option>
                      <option value="-">{lang.get('messages.nunca')}</option>
                      <option value="custom">{lang.get('messages.personalizado')}</option>
                    </select>
                  </div>
                </div>
                {custom ? (
                  <div className="row text-left">
                    <div className="col-sm-4 align-self-center form-group">
                      <input
                        data-date-format="yyyy-mm-dd"
                        className="form-control form-control-solid mb-5"
                        name="expired_date"
                        placeholder={lang.get('messages.fecha_de_expiracion')}
                        id="kt_daterangepicker_1"
                      />
                    </div>
                  </div>
                ) : null}
                <input type="submit" className="btn btn-primary" value={lang.get('messages.generar_token')} />
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ApiPersonPanel;
